import { Button, styled } from "@mui/material";

export const CustomButton = styled(Button)({
  "&.Mui-disabled": {
    color: "white", // Change text color as needed
  },
});
